export default __webpack_public_path__ + "9905c92f817887fdece1b2363ac2dd9a.png";